import { ELEMENTS_LOOKUP } from '../const'
import { IElement, IPage } from '../types'

/**
 * Whether a top-level page or section `children` array contains an element with the given id.
 * Defensive against undefined rows/columns/cells during drag-and-drop or header/footer replication.
 */
export function treeLevelContainsElementId(children: IElement[] | undefined | null, elementId: string): boolean {
  if (!children?.length || !elementId) return false
  return children.some(element => {
    if (!element) return false
    if (element.type === ELEMENTS_LOOKUP.ROW) {
      return (
        element.children?.some(column => {
          if (!column) return false
          return column.children?.some(c => c != null && c.id === elementId) ?? false
        }) ?? false
      )
    }
    return element.id === elementId
  })
}

/** Deep search: is `elementId` anywhere under these nodes? */
export function elementIdInSubtree(nodes: IElement[] | undefined, elementId: string): boolean {
  if (!nodes?.length || !elementId) return false
  for (const n of nodes) {
    if (!n) continue
    if (n.id === elementId) return true
    if (elementIdInSubtree(n.children, elementId)) return true
  }
  return false
}

/** Which page owns this element (body, header, or footer). */
export function resolvePageIdForElementInPages(pages: IPage[], elementId: string): string | undefined {
  if (!elementId) return undefined
  for (const page of pages) {
    if (elementIdInSubtree(page.children, elementId)) return page.id
    const headers = page.component?.options?.headers?.children
    const footers = page.component?.options?.footers?.children
    if (elementIdInSubtree(headers, elementId)) return page.id
    if (elementIdInSubtree(footers, elementId)) return page.id
  }
  return undefined
}
